// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SignupError__wrapper___Bn5Ca"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/SignupError.scss
// module id = cHFy
// module chunks = 0